export default "__VITE_ASSET__CIA__Tut__"